// pages/add_state_mobile.js
import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import './add_state_mobile.css';

// ==========================================
// Step 1: AddStateMobileStep1
// ==========================================
export function AddStateMobileStep1({ 
    patientName, diseaseCode, setDiseaseCode, status, setStatus, 
    weight, setWeight, height, setHeight, diseases, onNext, onBack 
}) {
    // حالة للبحث داخل الـ Combo Box
    const [searchTerm, setSearchTerm] = useState(diseaseCode || "");
    const [showDropdown, setShowDropdown] = useState(false);

    // فلترة الأمراض بناءً على المدخلات (البحث متاح بالاسم أو الرمز)
    const filteredDiseases = diseases.filter(d =>
        (d.disease_code && d.disease_code.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (d.name && d.name.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    return (
        <div className="mobile-add-state-container" dir="rtl">
            <div className="mobile-state-header">
                <i className="fa-solid fa-arrow-right mobile-state-back" onClick={onBack}></i>
                <h2>إضافة حالة طبية</h2>
            </div>

            <div className="mobile-state-stepper">
                <div className="mobile-step active">1</div>
                <div className="mobile-step-line"></div>
                <div className="mobile-step">2</div>
                <div className="mobile-step-line"></div>
                <div className="mobile-step">3</div>
            </div>

            <div className="mobile-state-form">
                <div className="mobile-state-input-group">
                    <label>* اسم المريض</label>
                    <input type="text" value={patientName || ""} disabled />
                </div>

                {/* Combo Box رمز المرض */}
                <div className="mobile-state-input-group">
                    <label>* رمز المرض</label>
                    <div className="mobile-autocomplete-wrapper">
                        <input 
                            type="text"
                            placeholder="ابحث عن رمز المرض..." 
                            value={searchTerm} 
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setDiseaseCode(e.target.value); 
                                setShowDropdown(true);
                            }}
                            onFocus={() => setShowDropdown(true)}
                            onBlur={() => {
                                // تأخير بسيط للسماح بحدث النقر بالعمل قبل إخفاء القائمة
                                setTimeout(() => setShowDropdown(false), 200);
                            }}
                            style={{ paddingLeft: '35px' }} // مساحة للأيقونة
                        />
                        {/* أيقونة القائمة المنسدلة */}
                        

                        {showDropdown && (
                            <div className="mobile-autocomplete-dropdown">
                                {filteredDiseases.length > 0 ? (
                                    filteredDiseases.map((disease) => (
                                        <div 
                                            key={disease.id || disease.disease_code}
                                            className="mobile-autocomplete-item"
                                            onClick={() => {
                                                // 1. عرض الرمز فقط للمستخدم داخل الحقل
                                                setSearchTerm(disease.disease_code); 
                                                // 2. تعيين الرمز في الـ State ليتم إرساله للباك إند
                                                setDiseaseCode(disease.disease_code); 
                                                setShowDropdown(false);
                                            }}
                                        >
                                            {/* إظهار الرمز والاسم في القائمة لتسهيل البحث */}
                                            <span style={{ fontWeight: '900', color: '#0b4f6f', marginLeft: '8px' }}>
                                                {disease.disease_code}
                                            </span>
                                            {disease.name && <span style={{ color: '#555', fontSize: '14px' }}>- {disease.name}</span>}
                                        </div>
                                    ))
                                ) : (
                                    <div className="mobile-autocomplete-empty">لا توجد أمراض مطابقة</div>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                <div className="mobile-state-input-group">
                    <label>* حالة المريض</label>
                    <div className="mobile-state-radio-group">
                        <label className="mobile-state-radio">
                            <input type="radio" value="infected" checked={status === 'infected'} onChange={(e) => setStatus(e.target.value)} />
                            مصاب
                        </label>
                        <label className="mobile-state-radio">
                            <input type="radio" value="cured" checked={status === 'cured'} onChange={(e) => setStatus(e.target.value)} />
                            متعافي
                        </label>
                    </div>
                </div>

                <div className="mobile-state-input-group">
                    <label>الوزن (kg)</label>
                    <input type="number" placeholder="مثال: 70" value={weight} onChange={(e) => setWeight(e.target.value)} />
                </div>
                
                <div className="mobile-state-input-group">
                    <label>الطول (cm)</label>
                    <input type="number" placeholder="مثال: 175" value={height} onChange={(e) => setHeight(e.target.value)} />
                </div>

                <div className="mobile-state-actions">
                    <button 
                        type="button" 
                        className="mobile-state-btn mobile-state-btn-primary" 
                        onClick={onNext}
                        disabled={!diseaseCode} // منع الانتقال إذا لم يتم إدخال/اختيار رمز المرض
                    >
                        التالي
                    </button>
                </div>
            </div>
        </div>
    );
}


// ==========================================
// Step 2: AddStateMobileStep2
// ==========================================
export function AddStateMobileStep2({ medicalRecord, handleChange, onNext, onBack }) {
    return (
        <div className="mobile-add-state-container" dir="rtl">
            <div className="mobile-state-header">
                <i className="fa-solid fa-arrow-right mobile-state-back" onClick={onBack}></i>
                <h2>السجل الطبي والتاريخ</h2>
            </div>

            <div className="mobile-state-stepper">
                <div className="mobile-step active">1</div>
                <div className="mobile-step-line active"></div>
                <div className="mobile-step active">2</div>
                <div className="mobile-step-line"></div>
                <div className="mobile-step">3</div>
            </div>

            <div className="mobile-state-form">
                <div className="mobile-state-input-group">
                    <label>الزمرة الدموية</label>
                    <select name="blood_type" value={medicalRecord.blood_type || ""} onChange={handleChange}>
                        <option value="">اختر الزمرة...</option>
                        <option value="A+">A+</option>
                        <option value="A-">A-</option>
                        <option value="B+">B+</option>
                        <option value="B-">B-</option>
                        <option value="AB+">AB+</option>
                        <option value="AB-">AB-</option>
                        <option value="O+">O+</option>
                        <option value="O-">O-</option>
                    </select>
                </div>

                <div className="mobile-state-input-group">
                    <label>الأمراض المزمنة</label>
                    <input list="chronic_list_mobile" name="chronic_diseases" placeholder="مثال: سكري، ضغط..." value={medicalRecord.chronic_diseases || ""} onChange={handleChange} />
                    <datalist id="chronic_list_mobile">
                        <option value="ضغط الدم" />
                        <option value="السكري" />
                        <option value="ربو" />
                    </datalist>
                </div>

                <div className="mobile-state-input-group">
                    <label>الحساسية الدوائية / الغذائية</label>
                    <input list="allergies_list_mobile" name="allergies" placeholder="مثال: بنسيلين..." value={medicalRecord.allergies || ""} onChange={handleChange} />
                </div>

                <div className="mobile-state-input-group">
                    <label>السوابق الجراحية</label>
                    <input list="surgical_list_mobile" name="surgical_history" placeholder="مثال: استئصال زائدة..." value={medicalRecord.surgical_history || ""} onChange={handleChange} />
                </div>

                <div className="mobile-state-input-group">
                    <label>اللقاحات</label>
                    <input list="vaccines_list_mobile" name="vaccines" placeholder="مثال: لقاح كوفيد-19..." value={medicalRecord.vaccines || ""} onChange={handleChange} />
                </div>

                <div className="mobile-state-actions">
                    <button type="button" className="mobile-state-btn mobile-state-btn-secondary" onClick={onBack}>رجوع</button>
                    <button type="button" className="mobile-state-btn mobile-state-btn-primary" onClick={onNext}>التالي</button>
                </div>
            </div>
        </div>
    );
}

// ==========================================
// Step 3: AddStateMobileStep3
// ==========================================
export function AddStateMobileStep3({ 
    diagnose, setDiagnose, diagnosisDate, setDiagnosisDate, 
    maritalStatus, setMaritalStatus, isSubmitting, onSubmit, onBack 
}) {
    return (
        <div className="mobile-add-state-container" dir="rtl">
            <div className="mobile-state-header">
                <i className="fa-solid fa-arrow-right mobile-state-back" onClick={onBack}></i>
                <h2>تفاصيل التشخيص</h2>
            </div>

            <div className="mobile-state-stepper">
                <div className="mobile-step active">1</div>
                <div className="mobile-step-line active"></div>
                <div className="mobile-step active">2</div>
                <div className="mobile-step-line active"></div>
                <div className="mobile-step active">3</div>
            </div>

            <form className="mobile-state-form" onSubmit={onSubmit}>
                <div className="mobile-state-input-group">
                    <label>* الحالة الاجتماعية</label>
                    <select value={maritalStatus} onChange={(e) => setMaritalStatus(e.target.value)} required disabled={isSubmitting}>
                        <option value="">اختر الحالة الاجتماعية...</option>
                        <option value="single">أعزب</option>
                        <option value="married">متزوج</option>
                        <option value="divorced">مطلق</option>
                        <option value="widow(er)">أرمل</option>
                    </select>
                </div>

                <div className="mobile-state-input-group">
                    <label>* تاريخ التشخيص</label>
                    <div style={{ width: '100%' }}>
                        <DatePicker 
                            selected={diagnosisDate} 
                            onChange={(date) => setDiagnosisDate(date)} 
                            dateFormat="yyyy-MM-dd" 
                            className="mobile-date-picker"
                            wrapperClassName="date-picker-wrapper"
                            disabled={isSubmitting}
                            required
                            customInput={
                                <input style={{width: "100%", padding: "14px 15px", borderRadius: "12px", border: "1.5px solid #e3edf5", background: "#fdfdfe"}} />
                            }
                        />
                    </div>
                </div>

                <div className="mobile-state-input-group">
                    <label>* تقرير التشخيص</label>
                    <textarea 
                        rows="4" 
                        placeholder="اكتب تفاصيل التشخيص هنا..." 
                        value={diagnose} 
                        onChange={(e) => setDiagnose(e.target.value)} 
                        disabled={isSubmitting}
                        required
                        style={{ padding: "14px", borderRadius: "12px", border: "1.5px solid #e3edf5", fontFamily: "inherit", resize: "vertical", outline: "none" }}
                    />
                </div>

                <div className="mobile-state-actions">
                    <button type="button" className="mobile-state-btn mobile-state-btn-secondary" onClick={onBack} disabled={isSubmitting}>
                        رجوع
                    </button>
                    <button type="submit" className="mobile-state-btn mobile-state-btn-primary" disabled={isSubmitting}>
                        {isSubmitting ? <i className="fa-solid fa-spinner fa-spin"></i> : "حفظ الحالة"}
                    </button>
                </div>
            </form>
        </div>
    );
}